export const BUSINESS = {
  name: "Padmavati Gem & Jewelss",
  shortName: "Padmavati",
  tagline: "Lab-Grown Diamond Specialists",
  proprietor: "Pratikkumar Narendrakumar Shah",
  phone: "+91 93269 37565",
  whatsapp: "919326937565",
  gst: "36ARYPS5502Q1ZP",
  shopReg: "SEA/HYD/ALO/12/1303985/2026",
  established: "April 2026",
  addressLines: [
    "5-9-224/1 & 2/SF/23, Mahalakshmi Gem Jewellers",
    "Chirag Ali Lane, Abids, Circle 12",
    "Hyderabad, Telangana 500001",
  ],
  hours: "Mon – Sat · 11:00 AM – 8:00 PM",
  mapsUrl: "https://www.google.com/maps/search/?api=1&query=Mahalakshmi+Gem+Jewellers+Chirag+Ali+Lane+Abids+Hyderabad+500001",
};

export const waLink = (text) =>
  `https://wa.me/${BUSINESS.whatsapp}?text=${encodeURIComponent(text)}`;

export const SHAPES = ["Round", "Oval", "Emerald", "Princess", "Cushion", "Pear", "Marquise", "Radiant", "Asscher", "Heart"];
